/*
 * Copyright (C) 2019 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import I18n from 'i18n!canvas_lazy_tray'
import React, {Suspense} from 'react'
import CanvasTray from 'jsx/shared/components/CanvasTray'
import {Spinner} from '@instructure/ui-spinner'
import {View} from '@instructure/ui-view'

// children should be a react `lazy`. This won't work properly otherwise.
export default function CanvasLazyTray({children, ...trayProps}) {
  const suspenseFallback = (
    <View as="div" textAlign="center">
      <Spinner renderTitle={I18n.t('Loading...')} />
    </View>
  )

  return (
    <CanvasTray {...trayProps}>
      <Suspense fallback={suspenseFallback}>{children}</Suspense>
    </CanvasTray>
  )
}
